// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2HMFB","sendOtp":"AuthorizeToLogin_sendOtp__1tYA0"};